import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FacultyService } from '../faculty.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-campus-google-map',
  templateUrl: './campus-google-map.component.html',
  styleUrls: ['./campus-google-map.component.scss']
})
export class CampusGoogleMapComponent implements OnInit {
  campusId: any;

  zoom = 15;

  center: google.maps.LatLngLiteral = {
    lat: 15.77874476,
    lng: 78.06332794
  };

  markers: any[] = [];

  constructor(private route: ActivatedRoute, private service: FacultyService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.campusId = params['location'];
      console.log('campusId', this.campusId);
    });
    this.showGoogleMap();
  }

  showGoogleMap() {
    this.spinner.show();
    this.service.getcampusGoogle(this.campusId).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return
        }
        if (res.length > 0) {
          this.center = {
            lat: parseFloat(res[0].latitude),
            lng: parseFloat(res[0].longitude)
          };
        }

        this.markers = res.map((b: any) => ({
          position: {
            lat: parseFloat(b.latitude),
            lng: parseFloat(b.longitude)
          },
          label: {
            text: b.buildingName,
            color: '#0564B1',     // BLUE COLOR
            fontSize: '14px',
            fontWeight: '400'
          },
          buildingId: b.buildingId
        }));

        console.log('GoogleMap', res);

      },
      error: (err: any) => {
        this.spinner.hide();
      }
    })
  }
}
